import * as tslib_1 from "tslib";
import { distinctUntilChanged, filter, map, share, switchMap, withLatestFrom } from 'rxjs/operators';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs';
import * as search from '../../catalog/actions/search.actions';
import * as status from '../actions/status.actions';
import * as menus from '../actions/menus.actions';
import * as fromRoot from '../../reducers';
import * as fromBase from '../reducers';
import * as fromCatalog from '../../catalog/reducers';
import { getFromUrlTerm } from '../../core/helpers/url-ready';
var HOMEPAGE_TYPE = 'home';
var SEARCH_PAGE_TYPE = 'search';
var ORDERHISTORY_PAGE_TYPE = 'orderhistory';
var StatusEffects = /** @class */ (function () {
    function StatusEffects(actions$, store, router) {
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.onNavigationStart$ = this.router.events.pipe(filter(function (ev) { return ev instanceof NavigationStart; }))
            .pipe(map(function (event) {
            var url = event.url;
            if (url.indexOf('?') !== -1)
                url = url.substring(0, url.indexOf('?'));
            return url.substring(1).split('/');
        }), distinctUntilChanged(null, function (urlSegments) { return urlSegments.join(''); }), switchMap(function (event) { return [new status.Set(), new menus.Init()]; }), share());
        this.onRouterNavigation$ = this.router.events.pipe(filter(function (ev) { return ev instanceof NavigationEnd; }))
            .pipe(map(function () { return new status.Apply(); }));
        this.onApplyStatus$ = this.actions$.ofType(status.APPLY, status.REAPPLY)
            .pipe(withLatestFrom(this.store.pipe(select(fromRoot.getRouterInfo)), this.store.pipe(select(fromBase.getPages)), this.store.pipe(select(fromCatalog.getSearchTerm)), function (action, router, pages, searchTerm) { return ({ router: router, pages: pages, searchTerm: searchTerm }); }), switchMap(function (data) {
            var url = data.router.url;
            if (url.indexOf('?') !== -1)
                url = url.substring(0, url.indexOf('?'));
            var urlSegments = url.substring(1).split('/');
            var pagesArr = data.pages;
            var searchTerm = '';
            var pageStatus;
            if (!urlSegments[0]) {
                pageStatus = {
                    trail: [],
                    current: pagesArr.find(function (page) { return page.type === HOMEPAGE_TYPE; }),
                    loadProducts: false
                };
            }
            else if (urlSegments[0].indexOf(SEARCH_PAGE_TYPE) > -1) {
                pageStatus = {
                    trail: [],
                    current: pagesArr.find(function (page) { return page.type === SEARCH_PAGE_TYPE; }),
                    loadProducts: true
                };
                searchTerm = getFromUrlTerm(urlSegments[urlSegments.length - 1]);
            }
            else {
                var currPage = pagesArr.find(function (page) { return page.slug === urlSegments.join('/'); });
                pageStatus = {
                    trail: [],
                    current: currPage,
                    loadProducts: (currPage !== undefined && currPage.type.toLowerCase() === 'catalog')
                };
                var segmentsArray = urlSegments;
                var currentSegment_1;
                for (var i = 0; i < segmentsArray.length; i++) {
                    var entry = null;
                    if (i === 0) {
                        currentSegment_1 = segmentsArray[i];
                        entry = pagesArr.find(function (page) { return page.slug === currentSegment_1; });
                        pageStatus.trail.push(entry);
                    }
                    else {
                        currentSegment_1 += "/" + segmentsArray[i];
                        entry = pagesArr.find(function (page) { return page.slug === currentSegment_1; });
                        pageStatus.trail.push(entry);
                    }
                }
            }
            var actionsArr = [
                new status.ApplySuccess(pageStatus),
                new menus.Navigate(pageStatus && pageStatus.current && pageStatus.current.code)
            ];
            if (searchTerm) {
                actionsArr.unshift(new search.SetSearchTerm(searchTerm));
            }
            if (!searchTerm && data.searchTerm) {
                actionsArr.unshift(new search.ClearSearchTerm());
            }
            return actionsArr;
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], StatusEffects.prototype, "onNavigationStart$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], StatusEffects.prototype, "onRouterNavigation$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], StatusEffects.prototype, "onApplyStatus$", void 0);
    return StatusEffects;
}());
export { StatusEffects };
